import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';

import { portfolioConfig } from 'components/Dashboards/Portfolio/portfolioConfig';
import { MapProject } from 'components/pages/PhasePerformanceManageMapProjectPage/components/MapProject/MapProject';

export const PhasePerformanceManageMapProjectPage = () => {
    useFullStoryPageView({ pageName: portfolioConfig.phasePerformanceManageMapProject.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <BottomHeaderSection>
                    <ProgramTopHeader
                        pageTitle={portfolioConfig.phasePerformanceManageMapProject.title}
                        showBack={true}
                    />
                </BottomHeaderSection>
            </HeaderWrapper>
            <MainContent>
                <MapProject />
            </MainContent>
        </PageContainer>
    );
};
